import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import DataMissing from './DataMissing';

interface IProps {
  vertical?: boolean;
}

interface IState {
  failed: boolean;
}

export default class Loading extends React.PureComponent<IProps, IState> {
  public state = {failed: false}
  public componentDidMount(){
    setTimeout( () => this.failToLoad(), 5000);
  }
  public failToLoad() {
    this.setState({failed: true})
  }
  public render() {
    if (this.state.failed === true) {
      return ( <DataMissing /> )
    }
    const vertical = this.props.vertical ? true : false;
    return (
     <div
       className={`w-full flex items-center justify-center ${
         vertical ? "flex-col" : "flex-row"
        }`}
      >
      <FontAwesomeIcon icon={faSpinner} spin={true} size="2x"/>
      <span className="p-4 text-lg font-bold font-montserrat">Loading...</span>
      </div>
  );
  }
  
};



// WEBPACK FOOTER //
// ./src/components/general/Loading.tsx